/**
 * WC Vendors - Stripe Commissions & Gateway - Refund component
 * https://www.wcvendors.com/product/wc-vendors-gateway-stripe-connect
 *
 * Licensed under the GPLv2+ license.
 */

window.WCVendorsStripeConnectRefund = window.WCVendorsStripeConnectRefund || {};

(function (window, document, $, plugin) {
	let $c = {};

	plugin.init = function () {
		plugin.cache();
		plugin.bindEvents();
		plugin.addValidator();
	};

	plugin.cache = function () {
		$c.window = $(window);
		$c.body = $(document.body);
		$c.refundAmountButtonLabel = $('.wc-order-refund-amount');
	};

	plugin.bindEvents = function () {
		$('.refund_order_item_qty').on('change', plugin.qtyChangeHandler);
		$('.refund input').on(
			'change',
			plugin.debounce(plugin.changeRefundTotal, 100)
		);
		$('.do-api-refund').on('click', plugin.refundHandler);
		$('.button.cancel-request').on('click', plugin.cancelRequest);
	};

	plugin.debounce = function (func, wait) {
		var timeout;

		return function () {
			var context = this,
				args = arguments;

			var executeFunction = function () {
				func.apply(context, args);
			};

			clearTimeout(timeout);
			timeout = setTimeout(executeFunction, wait);
		};
	};

	plugin.getRefundForm = function (el) {
		return el.closest('.wcv-modal').find('form.wcvendors-refund');
	};

	plugin.qtyChangeHandler = function () {
		var qty = parseFloat($(this).val()),
			maxQty = parseFloat($(this).attr('max')),
			$row = $(this).closest('tr'),
			lineCost = $row.find('td.line_cost').attr('data-sort-value'),
			cost = parseFloat(lineCost) / maxQty;

		if (qty > maxQty) {
			qty = maxQty;
		}

		$row.find('td.line_cost input.refund_line_total').val(
			plugin.formatPrice(qty * cost)
		);

		$row.find('td.line_tax').each(function () {
			var totalTax = parseFloat($(this).attr('data-total'));
			if (typeof totalTax !== typeof undefined && false !== totalTax) {
				$(this)
					.find('.refund_line_tax')
					.val(plugin.formatPrice((totalTax / maxQty) * qty));
			}
		});
	};

	plugin.formatPrice = function (price) {
		return Number(
			Number(price).toFixed(wcv_frontend_general.digits_after_decimal)
		)
			.toString()
			.replace('.', wcv_frontend_general.decimal_separator);
	};

	plugin.addValidator = function () {
		window.Parsley.addValidator('maxAmount', {
			validateString: function (value, max) {
				return (
					Number(
						value.replace(
							wcv_frontend_general.decimal_separator,
							'.'
						)
					) <= Number(max)
				);
			},
			messages: {
				en: WCVSCRefund.i18n_invalid_amount,
			},
		});
	};

	plugin.changeRefundTotal = function () {
		var $refundForm = plugin.getRefundForm($(this));
		var refundTotal = 0;
		var rawInput = $(this).val();
		var regex = new RegExp(
			'[^0-9' + wcv_frontend_general.decimal_separator + ']',
			'g'
		);

		$(this).val(rawInput.replace(regex, ''));

		$refundForm
			.find('.refund input:not(.refund_order_item_qty)')
			.each(function () {
				refundTotal += Number(
					$(this)
						.val()
						.replace(wcv_frontend_general.decimal_separator, '.')
				);
			});

		$refundForm
			.find('input[name="refund_amount"]')
			.val(plugin.formatPrice(refundTotal));
		$(this).closest('.wcv-modal').find('.js-refund-amount').html(plugin.formatPrice(refundTotal));
	};

	plugin.refundHandler = function () {
		var $refundForm = $(this).closest('.wcv-modal').find('form.wcvendors-refund');
		if (!window.confirm(WCVSCRefund.i18n_do_refund)) {
			return;
		}

		var refund_amount = $refundForm.find('#refund_amount').val();
		var refund_reason = $refundForm.find('#refund_reason').val();
		var refunded_amount = $refundForm.find('#refunded_amount').val();

		// Get line item refunds
		var line_item_qtys = {};
		var line_item_totals = {};
		var line_item_tax_totals = {};

		$refundForm
			.find('.refund input.refund_order_item_qty')
			.each(function (index, item) {
				if ($(item).closest('tr').data('order_item_id')) {
					if (item.value) {
						line_item_qtys[
							$(item).closest('tr').data('order_item_id')
						] = item.value;
					}
				}
			});

		$refundForm
			.find('.refund input.refund_line_total')
			.each(function (index, item) {
				if ($(item).closest('tr').data('order_item_id')) {
					line_item_totals[
						$(item).closest('tr').data('order_item_id')
					] = item.value;
				}
			});

		$refundForm
			.find('.refund input.refund_line_tax')
			.each(function (index, item) {
				if ($(item).closest('tr').data('order_item_id')) {
					var tax_id = $(item).data('tax_id');

					if (
						!line_item_tax_totals[
							$(item).closest('tr').data('order_item_id')
						]
					) {
						line_item_tax_totals[
							$(item).closest('tr').data('order_item_id')
						] = {};
					}

					line_item_tax_totals[
						$(item).closest('tr').data('order_item_id')
					][tax_id] = item.value;
				}
			});

		var data = {
			action: 'wcvendors_create_refund_request',
			order_id: $refundForm.attr('data-order-id'),
			refund_amount: refund_amount,
			refunded_amount: refunded_amount,
			refund_reason: refund_reason,
			line_item_qtys: JSON.stringify(line_item_qtys, null, ''),
			line_item_totals: JSON.stringify(line_item_totals, null, ''),
			line_item_tax_totals: JSON.stringify(
				line_item_tax_totals,
				null,
				''
			),
			api_refund: $(this).is('.do-api-refund'),
			restock_refunded_items: 'true',
			security: WCVSCRefund.order_item_nonce,
		};

		$.post(wcv_frontend_general.ajax_url, data, function (response) {
			if (true === response.success) {
				// Redirect to same page for show the refunded status
				window.location.href = WCVSCRefund.dashboard_request_url;
			} else {
				window.alert(response.data.error);
			}
		});
	};

	plugin.cancelRequest = function () {
		var user_confirm = window.confirm(
			WCVSCRefund.i18n_confirm_cancel_request
		);
		if (!user_confirm) {
			return;
		}
		var data = {
			action: 'wcvendors_cancel_refund_request',
			request_id: $(this).attr('data-request-id'),
			security: WCVSCRefund.cancel_request_nonce,
		};
		$.post(wcv_frontend_general.ajax_url, data, function (response) {
			if (true === response.success) {
				// Redirect to same page for show the refunded status
				window.location.href = WCVSCRefund.dashboard_request_url;
			} else {
				window.alert(response.data.error);
			}
		});
	};

	$(plugin.init);
})(window, document, jQuery, window.WCVendorsStripeConnectRefund);
